import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronDownIcon from 'assets/images/assist/icons/chevron-down.svg?react';
import {
  FAQ_ITEMS,
  FAQ_VISIBLE_COUNT,
} from '../HostfullyAssistMarketing.constants';
import {
  CopyStack,
  FaqList,
  FaqRow,
  FaqViewMoreButton,
  Overline,
  SectionHeading,
  SectionInner,
  WhiteSection,
} from '../HostfullyAssistMarketing.styles';
import FaqDisclosure from './FaqDisclosure';

const FaqsSection = () => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);
  const visibleItems = showAll
    ? FAQ_ITEMS
    : FAQ_ITEMS.slice(0, FAQ_VISIBLE_COUNT);

  return (
    <WhiteSection data-testid="assist-faqs">
      <SectionInner>
        <FaqRow>
          <CopyStack>
            <Overline>
              {t('pageHostfullyAssist.marketing.faq.overline')}
            </Overline>
            <SectionHeading>
              {t('pageHostfullyAssist.marketing.faq.headline')}
            </SectionHeading>
          </CopyStack>
          <FaqList>
            {visibleItems.map((item, index) => (
              <FaqDisclosure
                key={item.testId}
                item={item}
                index={index}
                defaultExpanded={index === 0}
              />
            ))}
            <FaqViewMoreButton
              type="button"
              aria-expanded={showAll}
              onClick={() => setShowAll((current) => !current)}
              data-testid="assist-faq-view-more"
            >
              {showAll
                ? t('pageHostfullyAssist.marketing.faq.viewLess')
                : t('pageHostfullyAssist.marketing.faq.viewMore')}
              <ChevronDownIcon
                aria-hidden
                data-testid="assist-faq-view-more-chevron"
              />
            </FaqViewMoreButton>
          </FaqList>
        </FaqRow>
      </SectionInner>
    </WhiteSection>
  );
};

export default FaqsSection;
